import { AbstractPmsApiService } from "./abstract.service";
import { SmsAccountSettings } from "../models";

/**
 * @class SmsAccountSettingsPmsApiService
 * @abstract
 * @extends {AbstractPmsApiService<SmsAccountSettings>}
 */
export class SmsAccountSettingsPmsApiService extends AbstractPmsApiService {

    /**
     * @type {string}
     * @protected
     */
    get urlPattern() {

        return '/property/:propertyId/sms-account-settings';
    }

    /**
     * @param {Object.<string, *>} attributes
     * @returns {SmsAccountSettings}
     * @protected
     */
    newModel(attributes, ...params) {

        return new SmsAccountSettings(attributes);
    }

    /**
     * @param {Property=} property
     * @returns {Promise.<SmsAccountSettings>}
     */
    get(property) {

        const url = this.url({propertyId: property.id});

        return this.http
            .get(url, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    /**
     * @param {Property} property
     * @param {SmsAccountSettings} smsAccountSettings
     * @returns {Promise.<SmsAccountSettings>}
     */
    save(property, smsAccountSettings) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url, smsAccountSettings, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }

    editBalance(property, smsAccountSettings) {

        const url = this.url({propertyId: property.id});

        return this.http
            .post(url + '/edit-balance', smsAccountSettings, {
                headers: this.authHeaders
            })
            .then(this.getModeler())
            .catch(this.getErrorHandler());
    }
}


// WEBPACK FOOTER //
// ./src/pms-api/services/sms-account-settings.service.js